export const GET_ADMIN_BULK_EDIT_JOBS = "GET_ADMIN_BULK_EDIT_JOBS"
export const GET_ADMIN_BULK_EDIT_JOBS_SUCCESS = "GET_ADMIN_BULK_EDIT_JOBS_SUCCESS"
export const GET_ADMIN_BULK_EDIT_JOBS_ERROR = "GET_ADMIN_BULK_EDIT_JOBS_ERROR"

export const EXPORT_ADMIN_BULK_EDIT_JOBS = "EXPORT_ADMIN_BULK_EDIT_JOBS"
export const EXPORT_ADMIN_BULK_EDIT_JOBS_SUCCESS = "EXPORT_ADMIN_BULK_EDIT_JOBS_SUCCESS"
export const EXPORT_ADMIN_BULK_EDIT_JOBS_ERROR = "EXPORT_ADMIN_BULK_EDIT_JOBS_ERROR"
